module.exports = __webpack_public_path__ + "static/media/3 10 Tulleord Blastell er feil.a88207b9.mp3";